import React from 'react';
import { contactInfo } from '../data/mock';
import { Mail, Phone, Instagram } from 'lucide-react';

const Footer = React.forwardRef((props, ref) => {
  return (
    <footer ref={ref} className="bg-[#3a3a3a] py-16 md:py-24 px-6">
      <div className="max-w-4xl mx-auto text-center">
        {/* Section Title */}
        <p 
          className="text-[#9a9a9a] text-lg md:text-xl mb-2 italic"
          style={{ fontFamily: "'Pinyon Script', cursive" }}
        >
          Lépj kapcsolatba velem
        </p>
        <h2 
          className="text-white text-3xl md:text-4xl lg:text-5xl mb-12"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Elérhetőségek
        </h2>
        
        {/* Contact Links - Large */}
        <div className="flex flex-col items-center gap-8 mb-12">
          <a 
            href={`mailto:${contactInfo.email}`}
            className="flex items-center gap-4 text-white hover:text-[#9cb88b] transition-colors"
          >
            <Mail className="w-8 h-8" />
            <span 
              className="text-2xl md:text-3xl"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {contactInfo.email}
            </span>
          </a>
          <a 
            href={`tel:${contactInfo.phone}`}
            className="flex items-center gap-4 text-white hover:text-[#9cb88b] transition-colors"
          >
            <Phone className="w-8 h-8" />
            <span 
              className="text-2xl md:text-3xl"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {contactInfo.phone}
            </span>
          </a>
          <a 
            href={`https://instagram.com/${contactInfo.instagram.replace('@', '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 text-white hover:text-[#9cb88b] transition-colors"
          >
            <Instagram className="w-8 h-8" />
            <span 
              className="text-2xl md:text-3xl"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {contactInfo.instagram}
            </span>
          </a>
        </div>
        
        {/* Copyright */}
        <p 
          className="text-white/50 text-sm"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          © {new Date().getFullYear()} The First Dance by Bogi. Minden jog fenntartva.
        </p>
      </div>
    </footer>
  );
});

Footer.displayName = 'Footer';

export default Footer;
